import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { FIELD_REGISTRY } from "./Config/fieldRegistry";

function ProductBasicInformation({
    formData,
    errors,
    handleChange,
    handleUserChange,
    loadSubCategory,
    loadDynamicDropdowns,
    brands,
    users = [],
    config,
    autoUserId

}) {
    const fields = config?.fields?.basic || [];
    const authAdmin = useSelector((state) => state.auth.admin);
    const selectedUser = users.find(
        (u) => String(u.id) === String(autoUserId)
    );
    const displayName =
        selectedUser?.name ||
        authAdmin?.business_name ||
        authAdmin?.name ||
        authAdmin?.email ||
        "Vendor";
    useEffect(() => {
        if (!autoUserId) return;
        if (formData.user_id === String(autoUserId)) return;
        if (!users || users.length === 0) return;
        const selectedUser = users.find(
            (user) => String(user.id) === String(autoUserId)
        );
        if (!selectedUser) return;
        const event = {
            target: { value: String(autoUserId) }
        };

        handleUserChange(
            event,
            users,
            loadSubCategory,
            loadDynamicDropdowns
        );

    }, [
        autoUserId,
        users,
        formData.user_id,
        handleUserChange,
        loadSubCategory,
        loadDynamicDropdowns
    ]);

    return (
        <div className="card shadow-sm">
            <div className="card-body">
                <div className="row">
                    {/* <div className="col-md-6 mb-3">
                        <label className="form-label">
                            User
                            <span className="text-danger">*</span>
                        </label>
                        {autoUserId ? (
                            <input
                                type="text"
                                className="form-control "
                                value={displayName}
                                disabled
                                readOnly
                            />
                        ) : (
                            <select
                                className={`form-control custumform  ${errors.user_id ? "is-invalid" : ""}`}
                                name="user_id"
                                value={formData.user_id || ""}
                                onChange={(e) =>
                                    handleUserChange(
                                        e,
                                        users,
                                        loadSubCategory,
                                        loadDynamicDropdowns,
                                    )
                                }
                            >
                                <option value="">Select User</option>
                                {users.map((user) => (
                                    <option key={user.id} value={user.id}>
                                        {user.name}
                                    </option>
                                ))}
                            </select>
                        )}
                        {errors.user_id && (
                            <div className="invalid-feedback">{errors.user_id}</div>
                        )}
                    </div> */}

             
                    <div className="col-md-6 mb-3">
                        <label className="form-label">
                            Product Name<span className="text-danger"> *</span>
                        </label>
                        <input
                            type="text"
                            className={`form-control ${errors.product_name ? "is-invalid" : ""}`}
                            placeholder="Enter Product Name"
                            name="product_name"
                            value={formData.product_name}
                            onChange={handleChange}
                        />
                        {errors.product_name && (
                            <div className="invalid-feedback">{errors.product_name}</div>
                        )}
                    </div>

                    {/* ✅ 3. BRAND */}
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Brand</label>
                        <select
                            className="form-control"
                            name="brand_id"
                            value={formData.brand_id}
                            onChange={handleChange}
                        >
                            <option value="">Select Brand</option>
                            {brands?.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* ✅ 4. DYNAMIC FIELDS */}
                    {fields.map((fieldName) => {
                        if (['user_id', 'product_name', 'brand_id'].includes(fieldName)) return null;

                        const fieldConfig = FIELD_REGISTRY[fieldName];
                        if (!fieldConfig) return null;

                        const { type, label, required, placeholder } = fieldConfig;

                        if (type === 'select') {
                            let options = fieldConfig.options || [];
                            return (
                                <div className="col-md-6 mb-3" key={fieldName}>
                                    <label className="form-label">
                                        {label} {required && <span className="text-danger">*</span>}
                                    </label>
                                    <select
                                        className={`form-control ${errors?.[fieldName] ? "is-invalid" : ""}`}
                                        name={fieldName}
                                        value={formData[fieldName] || ""}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select {label}</option>
                                        {Array.isArray(options) && options.map((opt) => (
                                            <option key={opt.value || opt} value={opt.value || opt}>
                                                {opt.label || opt}
                                            </option>
                                        ))}
                                    </select>
                                    {errors?.[fieldName] && (
                                        <div className="invalid-feedback">{errors[fieldName]}</div>
                                    )}
                                </div>
                            );
                        }

                        return (
                            <div className="col-md-6 mb-3" key={fieldName}>
                                <label className="form-label">
                                    {label} {required && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type={type === 'number' || type === 'price' ? 'number' : 'text'}
                                    className={`form-control ${errors?.[fieldName] ? "is-invalid" : ""}`}
                                    placeholder={placeholder || `Enter ${label}`}
                                    name={fieldName}
                                    value={formData[fieldName] || ""}
                                    onChange={handleChange}
                                    step={type === 'price' ? '0.01' : '1'}
                                />
                                {errors?.[fieldName] && (
                                    <div className="invalid-feedback">{errors[fieldName]}</div>
                                )}
                            </div>
                        );
                    })}

                </div>
            </div>
        </div>
    );
}

export default ProductBasicInformation;